<template>
    <div>
        <div class="form-box">
            <el-form ref="form" inline :model="queryForm" label-width="80px" style="text-align: center">
                <el-form-item>
                    <property-selector :value.sync="queryForm.property"></property-selector>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="queryForm.userName" clearable placeholder="Name"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input clearable v-model="queryForm.unitNo" placeholder="Unit"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input clearable v-model="queryForm.mobileNo" placeholder="Mobile No."></el-input>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                            clearable
                            v-model="queryForm.created"
                            format="dd MMM yyyy"
                            type="date"
                            placeholder="Submission Date"
                            value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-button type="primary" @click="loadData" icon="el-icon-search" size="medium" circle></el-button>
            </el-form>
        </div>
        <el-table
                v-loading="loading"
                fit
                stripe
                class="data-table"
                :data="data">
            <el-table-column
                    header-align="center"
                    align="center"
                    v-for="item in [
                        {label:'Property',prop:'propertyName',wth:'200px'},
                        {label:'Approved No. of QR Codes',prop:'approvedNumber',wth:'210px'},
                        {label:'Main Applicant Name',prop:'userName',wth:'200px'},
                        {label:'Unit',prop:'unit',wth:'160px'},
                        {label:'Approval Status',prop:'status',fmt:statusFmt,wth:'170px'},
                        {label:'Created Date',prop:'created',fmt:selfTimeFormat,wth:'200px'},
                        {label:'Approved Date',prop:'approved',fmt:selfTimeFormat,wth:'200px'},
                        {label:'Mcst Date',prop:'mastDate',fmt:selfTimeFormat,wth:'230px'},
                    ]"
                    :formatter="item.fmt"
                    :prop="item.prop"
                    :width="item.wth"
                    :label="item.label"
                    :key="item.label">
            </el-table-column>
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-table
                            fit
                            stripe
                            :data="props.row.items">
                        <el-table-column
                                header-align="center"
                                align="center"
                                v-for="item in [
                                {label:'Occupant Name',prop:'userName'},
                                {label:'Mobile Number',prop:'mobile'},
                                {label:'Access Card Number',prop:'userCard'},
                                {label:'Ownership Status',prop:'userRole'},
                                {label:'Tenancy Agreement Period',prop:'userPeriod'},
                                {label:'Tenancy Agreement Period',prop:'userPeriod'},
                                ]"
                                :prop="item.prop"
                                width="200px"
                                :label="item.label"
                                :key="item.label+'a'">
                        </el-table-column>
                    </el-table>
                </template>
            </el-table-column>
            <el-table-column
                    header-align="center"
                    align="center"
                    width="180px"
                    label="Action">
                <template slot-scope="s">
                    <el-button type="primary" v-if="s.row.mastStatus !==2" @click="update(s.row.id)">Intercom
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="page">
            <el-pagination @current-change="loadData"
                           :page-size="page.size"
                           :current-page.sync="page.page"
                           :page-count="page.totalPage"
                           layout="prev, pager, next"
                           :total="data.total">
            </el-pagination>
        </div>
    </div>
</template>

<script>

import {allProperty} from '@/api/AuthApi'
import {registerRecordsByConcierge, registerRecordsByConciergeUpdate} from '@/api/PropertyApi'
import PropertySelector from "@/components/PropertySelector";

export default {
    name: "RegisterRequests",
    components: {PropertySelector},
    data: function () {
        return {
            queryForm: {},
            page: {'page': 1, 'size': 10, 'totalPage': 1, 'total': 0},
            data: [],
            loading: false,
            propertyList: []
        }
    },
    methods: {
        statusFmt(row, cell, val) {
            return {2: 'Approved', 3: 'Partly Approved'}[val]
        },
        loadData() {
            this.$pageUtils(this, registerRecordsByConcierge)
        },
        update(id) {
            registerRecordsByConciergeUpdate(id)
                .then(() => this.loadData())
        }

    },
    mounted() {
        this.loadData()
        allProperty()
            .then(res => this.propertyList = res.data)
    }
}
</script>

<style scoped>
</style>
